import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle } from '../../shared/styles/buttons.styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useNoAttachedResourcesStyles = makeStyles(() => ({
  noAccessCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.md,
    maxWidth: 720,
    margin: '0 auto',
    padding: `${spacing.lg}px ${spacing.md}px`,
    borderRadius: radius.md,
    backgroundColor: colors.white,
    textAlign: 'center',
  },
  noAccessImage: {
    width: 160,
    maxWidth: '100%',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      width: 250,
    },
  },
  noAccessTitle: {
    margin: 0,
    fontFamily: fonts.gothicBold,
    fontSize: fontSize.base,
    color: colors.overlay,
    lineHeight: 1.4,
  },
  noAccessSubtitle: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.overlay,
    lineHeight: 1.4,
  },
  noAccessText: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.overlay,
    lineHeight: 1.4,
    '& a': {
      color: colors.primary,
    },
  },
  primaryButton: {
    ...primaryButtonStyle,
    minWidth: 146,
  },
}));
